/**
 * Whether a distance is worth putting on screen.
 *
 * Not every step source reports distance. Those members were rendering
 * "0 km recorded" beside a real step count, which reads as a measurement of
 * zero rather than as no measurement, and puts a nought next to the one number
 * that matters. Steps alone is the honest row.
 */
export function hasMeasuredDistance(meters) {
    return typeof meters === "number" && Number.isFinite(meters) && meters > 0;
}
//# sourceMappingURL=distance.js.map